import React from 'react'
import ErrorMessage from '../../UI/messages/ErrorMessage'
import WriteOffActTable from './WriteOffActTable'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import { setWriteOffActsCount, setWriteOffActsLimit, setWriteOffActsList, setWriteOffActsOffset } from '../../../store/writeOffSlice'
import { getWriteOffActsAPI } from '../../../api/writeOff/writeOffActAPI'

const WriteOffActList = () => {

    const writeOffActs = useSelector(state => state.writeOff.writeOffActs.list)
    const count = useSelector(state => state.writeOff.writeOffActs.count)
    const limit = useSelector(state => state.writeOff.writeOffActs.limit)
    const offset = useSelector(state => state.writeOff.writeOffActs.offset)
    const query = useSelector(state => state.writeOff.writeOffActs.query)
    const status = useSelector(state => state.writeOff.writeOffActs.filters.status)
    const departmentId = useSelector(state => state.writeOff.writeOffActs.filters.departmentId)
    const agreeDirector = useSelector(state => state.writeOff.writeOffActs.filters.agreeDirector)
    const agreeAccountant = useSelector(state => state.writeOff.writeOffActs.filters.agreeAccountant)
    const dispatch = useDispatch()

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        setLoading(true)
        setError('')
        getWriteOffActsAPI({ offset, limit, query, status, departmentId, agreeDirector, agreeAccountant }).then(data => {
            dispatch(setWriteOffActsCount(data.count))
            dispatch(setWriteOffActsList(data.writeOffActs))
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }, [limit, offset, query, status, departmentId, agreeDirector, agreeAccountant])

  return (
    <div>
        <ErrorMessage error={error} />
        
        <WriteOffActTable
            writeOffActs={writeOffActs}
            count={count}
            limit={limit}
            setLimit={e => dispatch(setWriteOffActsLimit(e))}
            offset={offset}
            setOffset={e => dispatch(setWriteOffActsOffset(e))}
            loading={loading}
        />
    </div>
  )
}

export default WriteOffActList